import axios from "axios";
import { toast } from "react-toastify";
import { LOGIN_USER } from "../../types/UserType";

const addUserAction = (data) => {
	return {
		type: LOGIN_USER,
		payload: data,
	};
};

export const superAdminLogin = (values) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/super-admin/login`,
				data: {
					...values,
				},
			});
			//dispatching data
			dispatch(addUserAction(data));
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("role", data.role || "superAdmin");
			localStorage.setItem("user", data.username);
			localStorage.setItem("id", data.id);
			localStorage.setItem("isLogged", true);
			localStorage.setItem("isSuperAdmin", "true");
			localStorage.setItem("isRequired", data.isRequired ? "true" : "false");
			
			if (data.isRequired) {
				toast.info("Please change your password to continue.");
				return { success: "success", isRequired: true };
			} else {
				toast.success("Super Admin Login Successfully Done");
				return { success: "success", isRequired: false };
			}
		} catch (error) {
			console.log(error.message);
			const errorMessage = error.response?.data?.message || "Incorrect Username or Password !";
			toast.error(errorMessage);
			return "error";
		}
	};
};
